import { indexedDBJSONStorage } from '../store/indexedDBStorage';
import { queryParamsService } from '../services/queryParams';

export const setPictureData = async (picture, data) => {
  let key = getPictureStorageKey(picture);
  await indexedDBJSONStorage.setItem(key, data);
};

export const getPictureData = async (picture) => {
  let key = getPictureStorageKey(picture);
  let data = await indexedDBJSONStorage.getItem(key);
  if (typeof data === 'string') {
    return data.replace(/^"|"$/g, '');
  }

  return data;
};

export const removePictureData = async (picture) => {
  let key = getPictureStorageKey(picture);
  await indexedDBJSONStorage.removeItem(key);
};

export const getFileData = async (file) => {
  let key = getFileStorageKey(file);
  let data = await indexedDBJSONStorage.getItem(key);
  if (typeof data === 'string') {
    return data.replace(/^"|"$/g, '');
  }
  return data;
};

export const setFileData = async (file, data) => {
  let key = getFileStorageKey(file);
  await indexedDBJSONStorage.setItem(key, data);
};

export const removeFileData = async (file) => {
  let key = getFileStorageKey(file);
  await indexedDBJSONStorage.removeItem(key);
};

const getPictureStorageKey = (picture) => {
  let sowKey = queryParamsService.getCacheKey();
  return sowKey + '-' + picture.id + '-' + (picture.fileName || '');
};

const getFileStorageKey = (file) => {
  let sowKey = queryParamsService.getCacheKey();
  return sowKey + '-' + file.id + '-' + (file.name || '');
};